import React from 'react';
import { FaBell, FaSearch, FaUserCircle } from 'react-icons/fa';
import { useAdminAuth } from '../context/AdminAuthContext'; // Correct context usage

const AdminHeader: React.FC = () => {
  // Context se direct name aur role nikalein
  const { name, role } = useAdminAuth();

  return (
    <header className="fixed top-0 right-0 h-20 left-64 bg-white/80 backdrop-blur-md border-b border-gray-100 flex items-center justify-between px-10 z-40">
      <div className="flex-1">
        <div className="relative max-w-md group">
          <FaSearch className="absolute left-5 top-1/2 -translate-y-1/2 text-gray-300 group-focus-within:text-[#006d5b] transition-colors" />
          <input 
            type="text" 
            placeholder="Search analytics..." 
            className="w-full bg-gray-50 border border-gray-100 rounded-2xl py-2.5 pl-14 pr-4 text-sm focus:outline-none focus:ring-2 focus:ring-[#006d5b]/10 focus:bg-white transition-all"
          />
        </div>
      </div>

      <div className="flex items-center gap-8">
        <button className="relative p-3 bg-gray-50 text-gray-400 hover:text-[#006d5b] rounded-2xl transition-all">
          <FaBell size={18} />
          <span className="absolute top-3 right-3 w-2 h-2 bg-[#006d5b] rounded-full border-2 border-white"></span>
        </button>

        <div className="flex items-center gap-4">
          <div className="text-right">
            {/* Dynamic Name from Context */}
            <p className="text-sm font-black text-gray-800 leading-none">
              {name || "Frog Head"}
            </p>
            {/* Dynamic Role from Context */}
            <p className="text-[10px] text-[#006d5b] font-bold uppercase tracking-tighter mt-1">
              {role ? role.replace('_', ' ') : "Super Admin"}
            </p>
          </div>
          <div className="w-12 h-12 rounded-2xl bg-[#006d5b] flex items-center justify-center text-white shadow-lg shadow-[#006d5b]/30">
            <FaUserCircle size={28} />
          </div>
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;